import React from 'react'
import { Container } from "react-bootstrap"
import MapPin from '../assets/images/location-icon-2.svg';
import { Link } from 'react-router-dom';
import useCities from '../hooks/useCities'
export default function BrowseCountry() {
  const { cities_detailed } = useCities();
  return (
    <div className="browse-country common-padding">
      <Container>
        <h2>
          Browse the newest homes from around the country
        </h2>
        <div className="browse-country-wrap">

          {cities_detailed.slice(0, 11).map((city, idx) => (
           <Link
  key={idx}
  to={`/search?city=${city.city_name}`}
  title={city.city_name}
  onClick={() => {
    sessionStorage.removeItem("fullSuburb");   // clear stale suburb
    sessionStorage.removeItem("searchFilters"); // clear stale deep filters
  }}
>
              <img src={MapPin} alt="" />
              {city.city_name}
            </Link>
          ))}


        </div>
      </Container>
    </div>
  );
}